import { ApolloClient, InMemoryCache } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';
import { apolloLink } from '../../../shared/data/apolloClient';

const vehicleDetailsApolloClient = new ApolloClient({
  link: apolloLink,
  cache: new InMemoryCache({
    typePolicies: {
      Organization: {
        fields: {
          suspects: relayStylePagination(),
        },
      },
      Vehicle: {
        fields: {
          attachments: relayStylePagination(),
          suspects: relayStylePagination(),
        },
      },
    },
  }),
});

export default vehicleDetailsApolloClient;
